module.exports = __webpack_public_path__ + "img/Product_Services_Open.e3a3f1a1.png";